"use client";
import React, {
  useEffect,
  useState,
  // useMemo
} from "react";
// import DownloadTable from "./widgets/downloaddata";
import {
  Box,
  Button,
  // CircularProgress,
  // FormControl,
  // InputLabel,
  // MenuItem,
  // Select,
  Snackbar,
  Typography,
  IconButton,
  // TextField,
} from "@mui/material";
// import Tables from "./widgets/tables";
// import { Column } from "primereact/column";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
// import * as XLSX from "xlsx";
import {
  // ToastContainer,
  toast,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CheckCircle } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useDispatch, useSelector } from "react-redux";
// import ButtonTabs from "./widgets/buttontabs";

import moment from "moment";
import {
  CreateGSlice,
  UpdateGameStatus,
  UpdateUserName,
  setData,
} from "../redux/slices/creategame";
import {
  setFilters,
  setPage,
  setRowsPerPage,
} from "../redux/slices/creategame";
import { keyframes } from "@emotion/react";
import DownloadData from "./widgets/downloaddata";
import { ablyClient, sendAblyMessage } from "../lib/socket";
// import { ApiSuccess } from "../redux/slices/cg";
import LazyTable from "./widgets/lazytable";

// Define rotation animation
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const channel = ablyClient.channels.get("admin-chennal");
const AddGame = () => {
  const dispatch = useDispatch();

  const { page, data, rowsPerPage, totalGames, loading, filters, approving } =
    useSelector((state) => state.cg);
  const user = useSelector((v) => v.login.user);

  const load = useSelector((state) => state.cg);

  // const [rowData, setRowData] = useState([]);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [isRefreshingAll, setIsRefreshingAll] = useState(false);
  console.log(isRefreshingAll, load);
  const headers = [
    "#",
    "User Name",
    "Game Name",
    "Game ID",
    "Game password",
    "Status",
  ];
  useEffect(() => {
    fetchData();
  }, [dispatch, page, rowsPerPage, filters]);

  const fetchData = () => {
    dispatch(CreateGSlice(page, rowsPerPage, filters));
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(event.target.value, 10));
    dispatch(setPage(0));
  };

  const handleRefreshAll = async () => {
    setIsRefreshingAll(true);
    try {
      await fetchData();
      toast.success("All games refreshed successfully!");
    } catch (error) {
      toast.error("Failed to refresh games");
      console.error("Refresh error:", error);
    } finally {
      setIsRefreshingAll(false);
    }
  };

  const handleAprrove = async (item) => {
    try {
      const payload = {
        _id: item._id,
        userid: item?.userid,
        gameid: item?.gameid,
        aid: user?.id,
        slug: item?.slug,
        name: item?.name,
        username: item?.username,
        password: item?.password,
        generate: false,
      };

      await dispatch(UpdateGameStatus(payload));
      await sendAblyMessage(
        "admin-chennal",
        item?.userid,
        "admin-456",
        "private",
      );
    } catch (error) {
      toast.error("Failed to refresh game credentials");
      console.error("Refresh error:", error);
    }
  };

  const tableData =
    data?.length > 0 &&
    data?.map((row, index) => [
      index + 1,
      row.name,
      row.game,
      row.username,
      `$${row.password}`,
      row.status,
    ]);

  // const sendAdminQuery = (userId) => {
  //   if (!userId) return;
  //   const channel = ably.channels.get("admin-channel");

  //   channel.publish("admin-message", {
  //     to: userId,
  //     payload: {
  //       action: "adminQuery",
  //       content: "Admin wants user info",
  //     },
  //   });
  // };

  useEffect(() => {
    const messageHandler = async (message) => {
      if (message?.data?.text) {
        dispatch(CreateGSlice(page, rowsPerPage, filters));
      }
    };

    channel.subscribe("admin-chennal", messageHandler);

    return () => {
      channel.unsubscribe("admin-chennal", messageHandler);
    };
  }, []);

  const handleEdit = (index, userId, field, newValue) => {
    const datas = data.map((item) =>
      item._id === userId ? { ...item, [field]: newValue, active: 0 } : item,
    );

    dispatch(setData(datas));
  };

  const handleSave = (rowData) => {};

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5">
          Add Game Requests
          <IconButton
            onClick={handleRefreshAll}
            disabled={loading}
            sx={{
              backgroundColor: "#3f51b5",
              ml: 2,
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
              animation: loading ? `${rotate} 1s linear infinite` : "none",
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <DownloadData
            headers={headers || []}
            tableData={tableData || []}
            fileName={"Add-game-requests"}
          />
        </Box>
      </Box>
      {/* <Box>
        <ButtonTabs />
      </Box> */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Please select an export format."
        onClose={() => setOpenSnackbar(false)}
      />

      <LazyTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalGames}
        loading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onFilterChange={(filters) => {
          dispatch(setFilters(filters));
        }}
        columns={[
          { field: "name", headerName: "User Name", filter: true },
          { field: "game", headerName: "Game Name", filter: true },
          {
            field: "username",
            headerName: "Game ID",
            filter: true,
            render: (rowData, index) => {
              return (
                <UsernameCell
                  rowData={rowData}
                  index={index}
                  field="username"
                  onEdit={handleEdit}
                  onSave={handleSave}
                />
              );
            },
          },
          {
            field: "password",
            headerName: "Game Pass",
            filter: true,
            render: (rowData, index) => (
              <UsernameCell
                rowData={rowData}
                field="password"
                index={index}
                onEdit={handleEdit}
                onSave={() => {}}
              />
            ),
          },
          {
            field: "active",
            headerName: "Status",
            filter: true,
            render: (rowData) => (
              <Box
                sx={{
                  color: rowData.active === 1 ? "green" : "orange",
                  fontWeight: "bold",
                }}
              >
                {rowData.active === 1 ? "Active" : "Pending"}
              </Box>
            ),
          },
          {
            field: "createdAt",
            headerName: "Created At",
            filter: true,
            render: (rowData) => {
              if (rowData.createdAt) {
                const date = moment(rowData.createdAt);
                if (date.isValid()) {
                  return date.format("MMM DD, YYYY hh:mm A");
                }
              }
              return null;
            },
          },
          {
            field: "actions",
            headerName: "Actions",
            render: (rowData) =>
              rowData.active === 0 ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  loading={approving._id === rowData._id}
                  disabled={approving._id === rowData._id}
                  onClick={() => handleAprrove(rowData)}
                >
                  Approve
                </Button>
              ) : null,
          },
        ]}
      />

      {/* <Tables rowData={data}>
        <Column
          header="#"
          body={(rowData, options) => options.rowIndex + 1}
          filter
          filterPlaceholder="Search by SrNo"
        />
        <Column
          field="name"
          header="User  Name"
          filter
          filterPlaceholder="Search by User Name"
        />
        <Column
          field="game"
          header="Game Name"
          filter
          filterPlaceholder="Search by Game Name"
        />

        <Column
          field="username"
          header="Game ID"
          filter
          filterPlaceholder="Search by Game ID"
          body={(rowData, index) => (
            <UsernameCell
              rowData={rowData}
              index={index}
              field="username"
              onEdit={handleEdit}
            />
          )}
        />

        <Column
          field="password"
          header="Game Pass"
          filter
          filterPlaceholder="Search by Game Password"
          body={(rowData, index) => (
            <UsernameCell
              rowData={rowData}
              field="password"
              index={index}
              onEdit={handleEdit}
            />
          )}
        />

        <Column
          field="createdAt"
          header="Date"
          filter
          body={(rowData) => moment(rowData?.createdAt).format("L LT")}
          filterPlaceholder="Search by Date"
        />
        <Column
          field="active"
          header="Status"
          filter
          filterPlaceholder="Search by Status"
          body={(rowData) => (
            <Box
              sx={{
                color: rowData.active === 1 ? "green" : rowData.active === 404 ? "red" : "orange",
                fontWeight: "bold",
              }}
            >
              {rowData.active === 1 ? "Active" : rowData.active === 404 ? "rejected" : "Pending"}
            </Box>
          )}
        />

        <Column
          header="Action"
          body={(rowData) =>
            rowData.active === 0 ? (
              <div className="flex gap-2">
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => handleAprrove(rowData)}
              >
                Approve
              </Button>
              <Button
              variant="contained"
              color="warning"
              size="small"
              onClick={() => handleReject(rowData)}
            >
              Reject
            </Button>
            </div>
            ) : null
          }
        />
      </Tables> */}

      {/* Snackbar for notifications */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Action completed"
        onClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};

const UsernameCell = ({ rowData, field, index, onEdit }) => {
  const [submitting, setSubmitting] = useState(false);
  const [isActive, setIsActive] = useState(false); // track input focus
  const dispatch = useDispatch();

  const safeCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success("Copied to clipboard!"))
      .catch(() => toast.error("Failed to copy!"));
  };

  const handleSave = async (item) => {
    setSubmitting(true);
    const payload = {
      userid: rowData?.userid,
      gameid: rowData?.gameid,
      [field]: rowData[field],
    };
    await dispatch(UpdateUserName(payload));
    setSubmitting(false);
  };

  const handleChange = (e) => {
    onEdit(index, rowData?._id, field, e.target.value);
  };

  const value = rowData?.[field] ?? "";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {rowData.active === 1 ? (
        value
      ) : (
        <input
          maxLength={15}
          type="text"
          value={value}
          onChange={handleChange}
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          style={{
            padding: "4px 6px",
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />
      )}

      <span className="text-md text-gray-800 cursor-pointer">
        {!submitting && isActive && (
          <CheckCircle
            onMouseDown={(e) => e.preventDefault()} // prevent blur
            onClick={handleSave}
            sx={{
              fontSize: 18, // adjust size in pixels
              color: "gray", // change color
              cursor: "pointer",
            }}
          />
        )}{" "}
        {!submitting && !isActive && (
          <ContentCopyIcon
            className="ml-1 cursor-pointer"
            fontSize="inherit"
            onClick={() => safeCopy(value)}
          />
        )}
      </span>

      {submitting && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            animation: "rotate 1s linear infinite",
          }}
        >
          <RefreshIcon fontSize="inherit" />
        </Box>
      )}
    </Box>
  );
};

export default AddGame;
